import styled from 'styled-components';

export const Title = styled.h3`
  color: ${(props) => props.theme.colors['neutral-100']};
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 8px;
`;

export const PageTitle = styled.h2`
  margin-bottom: 42px;
  font-size: 18px;
  line-height: 21px;
  font-weight: 600;
  color: ${(props) => props.theme.colors['neutral-100']};
`;

export const Figure = styled.figure`
  border-radius: 10.04px;
  overflow: hidden;
  margin-bottom: 16px;
`;

export const PublishedAt = styled.p`
  font-size: 14px;
  margin-bottom: 40px;
  line-height: 21px;
  color: ${(props) => props.theme.colors['neutral-100']};
`;
